import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img 
          src="/logo.png" 
          alt="Sykkelfest logo" 
          className="not-found-logo"
        />
        <h1 className="not-found-title">Har du syklet deg bort?</h1>
        <p className="not-found-message">
          Oops! Denne siden finnes ikke. <br />Kanskje du tok feil sving på veien?
        </p>
        <p className="not-found-submessage">
          Ikke bekymre deg - vi hjelper deg tilbake på riktig spor!
        </p>
        <button 
          className="not-found-button"
          onClick={() => navigate('/')}
        >
          Ta meg tilbake til forsiden
        </button>
        <p className="not-found-error-code">404 - Side ikke funnet</p>
      </div>
    </div>
  );
};

export default NotFound;
